import { FC, useContext, useState } from 'react'
import { useQuery } from '@apollo/client'
import { Select } from 'antd'
import { translate } from '../../../core'
import { getItemTypeSelectOptions } from '../func/type-options'
import { PurchaseOrderFindVendorsQuery } from '../graphql/purchase-order.graphql'
import { PurchaseOrderEntryContext } from './PurchaseOrderEntryContext'
import styles from './PurchaseOrderEntry.module.scss'

export const PurchaseOrderEntryContextBar: FC = () => {
  const { type, vendorIds, vendorLabels, setType, setVendors } = useContext(PurchaseOrderEntryContext)
  const [contactIdSearch, setContactIdSearch] = useState<string>()

  const { data, loading } = useQuery(PurchaseOrderFindVendorsQuery, {
    variables: {
      request: {
        take: 20,
        skip: 0,
        type,
        contactId: contactIdSearch,
      },
    },
  })

  const vendors = data?.purchaseOrderFindVendors.data ?? []

  const knownLabelOf = (id: number) =>
    vendors.find(vendor => vendor.id === id)?.contactId ?? vendorLabels[id]

  const vendorOptions = [
    ...vendors.map(vendor => ({ label: vendor.contactId, value: vendor.id })),
    ...vendorIds
      .filter(id => !vendors.some(vendor => vendor.id === id))
      .map(id => ({ label: knownLabelOf(id) ?? `#${id}`, value: id })),
  ]

  return (
    <>
      <div className={styles.field}>
        <span className={styles.fieldLabel}>{translate('product_type')} *</span>
        <Select
          className={styles.typeSelect}
          value={type}
          onChange={setType}
          options={getItemTypeSelectOptions()}
        />
      </div>

      <div className={styles.field}>
        <span className={styles.fieldLabel}>{translate('vendor_optional')}</span>
        <Select
          className={styles.vendorSelect}
          mode='multiple'
          allowClear
          maxTagCount='responsive'
          placeholder={translate('all_vendors')}
          loading={loading}
          value={vendorIds}
          onChange={(ids: number[]) => setVendors(ids.map(id => ({ id, contactId: knownLabelOf(id) })))}
          onSearch={setContactIdSearch}
          onDropdownVisibleChange={open => !open && setContactIdSearch(undefined)}
          filterOption={false}
          options={vendorOptions}
        />
      </div>

      <span className={styles.contextHint}>{translate('po_builder_live_hint')}</span>
    </>
  )
}
